'use client'

import { useTranslation } from 'next-i18next'
import Image from 'next/image'
import { Rating } from 'react-simple-star-rating'

export default function Review() {
  const { t } = useTranslation('password-generator')
  return (
    <section className="py-12 lg:py-24">
      <div className="max-w-[1280px] xl:px-0 px-5 mx-auto">
        <span className="block text-center text-xl font-semibold text-heading-desctiption mb-6">
          We are on
        </span>
        <div className="flex items-center justify-center flex-wrap gap-12 mb-16">
          <Image
            width={100}
            height={32}
            className="min-w-[100px] w-auto"
            src="/images/password-generator/Trustpilot.svg"
            alt="Locker Pasword Generator"
          />
          <Image
            width={100}
            height={32}
            className="min-w-[100px] w-auto"
            src="/images/password-generator/Getapp.svg"
            alt="Locker Pasword Generator"
          />
          <Image
            width={100}
            height={32}
            className="min-w-[100px] w-auto"
            src="/images/password-generator/AppStore.svg"
            alt="Locker Pasword Generator"
          />
          <Image
            width={100}
            height={32}
            className="min-w-[100px] w-auto"
            src="/images/password-generator/GooglePlay.svg"
            alt="Locker Pasword Generator"
          />
          <Image
            width={100}
            height={32}
            className="min-w-[100px] w-auto"
            src="/images/password-generator/G2.svg"
            alt="Locker Pasword Generator"
          />
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-8">
          <div className="col-span-1 rounded-lg border border-solid border[#D0D5DD] p-6 gap-6 flex flex-col justify-between">
            <div className="space-y-6">
              <div className="flex justify-between items-center">
                <Rating initialValue={5} size={22} readonly />
                <Image
                  width={32}
                  height={32}
                  className="w-auto"
                  src="/images/password-generator/G2.svg"
                  alt="Locker Pasword Generator"
                />
              </div>
              <p className="text-gray-700 space-y-3">
                <span className="inline-block">
                  {' '}
                  In our company we work with other people and companies, and its hard to keep safe
                  all of their sensitive data, like passwords. For us to be able to do our job, we
                  need their passwords but we also need them to be protected and having them all in
                  one place, has saved us lots of time. We can share the save passwords with no
                  risk, it is amazing!
                </span>
                <span className="inline-block">
                  So far, I've liked everything. Ill keep using Locker Password Manager in my
                  company.
                </span>
              </p>
              <a
                href="https://www.capterra.com/p/265084/Locker-Password-Manager/reviews/4680152/"
                target="_blank"
                rel="noopener noreferrer"
                className="font-semibold text-primary-HOVER text-sm flex items-center gap-2"
              >
                <span>Đọc review</span>
                <Image
                  width={16}
                  height={16}
                  src="/images/blog/link.svg"
                  className="w-4 h-4 object-contain"
                  alt="Locker logo social"
                />
              </a>
            </div>
            <div className="flex items-center gap-4">
              <Image
                src={'/images/password-generator/Author.svg'}
                width={50}
                height={50}
                className="rounded-full"
              />
              <div className="spacy-y-[2px]">
                <span className="block font-semibold text-gray-700 text-lg">Maria Gabriela R.</span>
                <span className="text-xs text-gray-700">Social media manager</span>
              </div>
            </div>
          </div>
          <div className="col-span-1 rounded-lg border border-solid border[#D0D5DD] p-6 gap-6 flex flex-col justify-between">
            <div className="space-y-6">
              <div className="flex justify-between items-center">
                <Rating initialValue={5} size={22} readonly />
                <Image
                  width={32}
                  height={32}
                  className="w-auto"
                  src="/images/password-generator/G2.svg"
                  alt="Locker Pasword Generator"
                />
              </div>
              <p className="text-gray-700 space-y-3">
                <span className="inline-block">
                  Thus far, I have been extremely pleased with Locker. I have used several password
                  managers over the years, and I would have to say that Locker does a better job of
                  capturing new passwords than any of the others. Likewise, Locker does a great job
                  of entering your password information for websites that you visit. I have yet to
                  run across a website that Locker was unable to complete the login process for me
                  automatically. The security and syncing of data both appear to be top-notch. I
                  have encountered no bugs/errors in the online vault or browser extension. Locker
                  is basically the password manager that I have been waiting for.
                </span>
              </p>
              <a
                href="https://www.capterra.com/p/265084/Locker-Password-Manager/reviews/6169548/"
                target="_blank"
                rel="noopener noreferrer"
                className="font-semibold text-primary-HOVER text-sm flex items-center gap-2"
              >
                <span>Đọc review</span>
                <Image
                  width={16}
                  height={16}
                  src="/images/blog/link.svg"
                  className="w-4 h-4 object-contain"
                  alt="Locker logo social"
                />
              </a>
            </div>
            <div className="flex items-center gap-4">
              <Image
                src={'/images/default-avatar.svg'}
                width={50}
                height={50}
                className="rounded-full"
                alt="Locker Pasword Generator"
              />
              <div className="spacy-y-[2px]">
                <span className="block font-semibold text-gray-700 text-lg">Chris A.</span>
                <span className="text-xs text-gray-700">Planning Analyst</span>
              </div>
            </div>
          </div>
          <div className="col-span-1 rounded-lg border border-solid border[#D0D5DD] p-6 gap-6 flex flex-col justify-between">
            <div className="space-y-6">
              <div className="flex justify-between items-center">
                <Rating initialValue={5} size={22} readonly />
                <Image
                  width={32}
                  height={32}
                  className="w-auto"
                  src="/images/password-generator/G2.svg"
                  alt="Locker Pasword Generator"
                />
              </div>
              <p className="text-gray-700 space-y-3">
                <span className="inline-block">
                  As far i am using it, all good, design slick, feature awesome and can detect
                  autofill correctly. Lifetime membership, and multi device synch, that is the most
                  important thing, and off course the zero knowledge feature. So far so good, i have
                  no complain at all. Compare enpass its cheaper with more good design, compare to
                  roboform its have lifetime plan
                </span>
              </p>
              <a
                href="https://www.capterra.com/p/265084/Locker-Password-Manager/reviews/6349287/"
                target="_blank"
                rel="noopener noreferrer"
                className="font-semibold text-primary-HOVER text-sm flex items-center gap-2"
              >
                <span>Đọc review</span>
                <Image
                  width={16}
                  height={16}
                  src="/images/blog/link.svg"
                  className="w-4 h-4 object-contain"
                  alt="Locker logo social"
                />
              </a>
            </div>
            <div className="flex items-center gap-4">
              <Image
                src={'/images/default-avatar.svg'}
                width={50}
                height={50}
                className="rounded-full"
                alt="Locker Pasword Generator"
              />
              <div className="spacy-y-[2px]">
                <span className="block font-semibold text-gray-700 text-lg">Nurul H.</span>
                <span className="text-xs text-gray-700">Programmers</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
